import React from 'react';
import { LocaleContext } from './context';
import { fetchLocale, translateUrl } from './utils';
import { useNavigator } from '../Navigator/hooks';

const { Provider: RawLocaleProvider } = LocaleContext;

const LocaleProvider = ({ children }) => {
  const locale = fetchLocale();
  const navigate = useNavigator();

  const handleSetLocale = (locale) => {
    const nextUrl = translateUrl(window.location.href, locale);
    navigate(nextUrl);
    window.location.reload();
  };

  return (
    <RawLocaleProvider
      value={{ locale, setLocale: handleSetLocale }}
      setLocale={handleSetLocale}
    >
      {children}
    </RawLocaleProvider>
  );
};

export default LocaleProvider;
